import { fetchWithAuth } from "../api/client";
import { User, ErrorResponse, EmptyResponse } from "../types";
type UserServer = Omit<User, "status"> & {
  status: number;
};
export async function getInfoUserAuth(
  token: string
): Promise<UserServer | ErrorResponse> {
  const res = await fetchWithAuth(`Auth/user-info`, {
    method: "GET",
    token,
  });
  if (!res.ok) {
    return {
      error: res.status,
      message: `Error fetching user: ${res.statusText}`,
    };
  }
  return await res.json();
}
